export default __webpack_public_path__ + "static/media/blockimg-servidor-legal.2b2843e9.png";